"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.URL = exports.windowGlobal = void 0;

var _windowGlobal;

function emptyFn() {}

var windowGlobal = function windowGlobal() {
  return typeof window !== 'undefined' && window;
};

exports.windowGlobal = windowGlobal;
var URL = ((_windowGlobal = windowGlobal()) == null ? void 0 : _windowGlobal.URL) || emptyFn;
exports.URL = URL;